import React from 'react'

const AddTargetGroupIcon = (props) => (
  <svg width='18' height='17' viewBox='0 0 18 17' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M1.00192 13.6274C1.00192 14.7958 1.94931 15.7432 3.1177 15.7432H14.2501C15.7682 15.7432 17 14.5114 17 12.9933V7.6183C17 5.96181 15.6567 4.61854 14.0002 4.61854H13.1105H11.4405C10.8794 4.61854 10.3413 4.39563 9.94355 3.99784L7.67788 1.73216C7.20898 1.26327 6.5729 1 5.90992 1H3.11578C1.94739 1 1 1.94739 1 3.11578V5.53519' stroke='#33354D' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M1.00195 9.35553H4.01709' stroke='#33354D' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M6.2002 9.35553H7.14759' stroke='#33354D' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M4.13232 6.22507V12.4859' stroke='#33354D' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
)
export default AddTargetGroupIcon
